import { Departments } from '@shared/utils/constants';
import { MenuItemSection } from './getMenuItems';

const OPERATIONS_ITEMS: MenuItemSection[] = [
	'HOME',
	'ADMIN',
	'FIXTURES',
	'CARGOS',
	'VOYAGES',
	'HEAD_FIXTURES',
	'VESSELS',
	'COUNTERPARTIES',
	'MAP',
	'EXPENSES',
];

const FINANCE_ITEMS: MenuItemSection[] = [
	'HOME',
	'ADMIN',
	'FIXTURES',
	'VOYAGES',
	'HEAD_FIXTURES',
	'VESSELS',
	'COUNTERPARTIES',
	'MAP',
	'EXPENSES',
	'ACCOUNTING_ITEMS',
	'ACCOUNTING',
];

const CHARTERING_ITEMS: MenuItemSection[] = [
	'HOME',
	'ADMIN',
	'FIXTURES',
	'CARGOS',
	'VOYAGES',
	'HEAD_FIXTURES',
	'VESSELS',
	'COUNTERPARTIES',
	'MAP',
];

const MANAGEMENT_ITEMS: MenuItemSection[] = [
	'HOME',
	'ADMIN',
	'APPROVALS',
	'COMPANY_SETTINGS',
	'MAP',
	'FIXTURES',
	'CARGOS',
	'VOYAGES',
	'HEAD_FIXTURES',
	'VESSELS',
	'COUNTERPARTIES',
];

const ADMIN_ITEMS: MenuItemSection[] = Array.from(
	new Set([...MANAGEMENT_ITEMS, ...CHARTERING_ITEMS, ...OPERATIONS_ITEMS, ...FINANCE_ITEMS]),
);

const departmentToMenuItemsMap = {
	[Departments.CHARTERING.key]: CHARTERING_ITEMS,
	[Departments.OPERATIONS.key]: OPERATIONS_ITEMS,
	[Departments.FINANCE.key]: FINANCE_ITEMS,
	[Departments.MANAGEMENT.key]: MANAGEMENT_ITEMS,
	[Departments.ADMIN.key]: ADMIN_ITEMS,
};

export const getDepartmentMenuItems = (department: string) => (
	departmentToMenuItemsMap[department as keyof typeof departmentToMenuItemsMap] || CHARTERING_ITEMS
);
